export default "__VITE_ASSET__e2980402__"